<template>
  <div>
    <div class="modal is-active">
      <div class="modal-background" @click="$emit('closeModal')"></div>
      <div class="modal-content">
        <div class="rdv-header">
          <div class="is-size-4 is-size-5-mobile has-font-weight-bold">
            {{ prestations }}
          </div>
          <div v-if="agenda" class="is-size-5 is-size-6-mobile pb-1">
            {{ agenda.internet_name || agenda.name }}
          </div>
        </div>
        <div class="rdv-info-body">
          <p class="has-text-centered" v-if="start_date"></p>
          <p v-if="config.display_duration">
            <span class="icon is-large">
              <i class="fa fa-clock fa-lg"></i>
            </span>
            {{ duration }}
          </p>
          <p v-if="config.display_price">
            <span class="icon is-large">
              <i class="fa fa-euro-sign fa-lg"></i>
            </span>
            {{ price }}
          </p>
          <div class="columns mb-0 is-mobile" v-if="location">
            <div
              class="column is-narrow is-flex is-flex-direction-column is-justify-content-center pr-0 pb-0"
            >
              <span class="icon is-large pb-0"
                ><i class="fa fa-map-marker-alt fa-lg"></i
              ></span>
            </div>
            <div class="column px-0 pb-0">
              <p>{{ location.name }}</p>
              <p>{{ renderLocationAddress(location) }}</p>
            </div>
          </div>

          <p v-if="start_date">
            <span class="icon is-large">
              <i class="fa fa-clock fa-lg"></i>
            </span>
            {{ start_date }}
          </p>

          <div
            class="buttons is-flex is-justify-content-flex-end pr-4"
            v-if="start_date && !this.paymentEnabled"
          >
            <button
              v-if="!this.paymentEnabled"
              id="btn-confirm" :class="
                is_loading
                  ? 'button is-info is-rounded is-loading'
                  : 'button is-info is-rounded'
              "
              @click="createRdv"
            >
              Confirmer le rendez-vous
            </button>
          </div>
          <div class="columns buttons mx-2">
            <button
              v-if="this.stripeEnabled"
              :class="
                is_loading
                  ? 'column button is-link is-loading'
                  : 'column button is-link'
              "
              @click="stripePayment"
            >
              Payer avec Stripe
            </button>
            <div class="column" v-if="this.paypalEnabled" ref="paypal" ></div>
          </div>
        </div>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="$emit('closeModal')"
      ></button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { toast } from "bulma-toast";
import { createPaypalBnt, stripeHandlePayment } from "../../../payment";
export default {
  props: [
    "rdv_data",
    "price",
    "duration",
    "prestations",
    "location",
    "agenda",
    "start_date",
    "config",
  ],
  data() {
    return {
      is_loading: false,
    };
  },
  mounted() {
    if (this.paypalEnabled) {
      const paypalBtn = this.$refs.paypal;
      createPaypalBnt(
        ()=>this.$props.rdv_data,
        ()=>this.$inertia.get("/"),
        ()=>{},
       ).render(paypalBtn);
    }
  },
  computed: {
    paymentEnabled: function(){
      return this.config.enable_paiement != 0 &&  0 < +this.price.replace(/[^0-9.]/,'');
    },
    paypalEnabled: function() {
      return this.paymentEnabled && window.paypal;
    },
    stripeEnabled: function(){
      return this.paymentEnabled && window.stripe;
    }
  },

  methods: {
    stripePayment(){
      stripeHandlePayment(this.$props.rdv_data).then((url)=>{
        document.location = url;
      })
    },
    createRdv() {
      this.is_loading = true;

      axios
        .post("rdv/add_rdv", this.rdv_data)
        .then((response) => {
          this.is_loading = false;
          this.$inertia.get("/");
        })
        .catch((err) => {
          toast({
            message:
              err?.response?.data?.message ||
              "Le rendez-vous n'a pas pu être créé.",
            type: "is-danger",
            duration: 5000,
            pauseOnHover: true,
          });
          this.is_loading = false;
        });
    },
    renderLocationAddress(location) {
      if (!location.address) return "";
      let localisation_regex =
        /((\-?|\+?)?\d+(\.\d+)?),\s*((\-?|\+?)?\d+(\.\d+)?)/;
      return location.address
        .split(" ")
        .filter((elt) => !elt.match(localisation_regex))
        .join(" ");
    },
  },
};
</script>
<style scoped>
.rdv-header {
  background-color: var(--card-header-bg-color);
  color: var(--card-header-text-color);
  border-radius: 20px;
  text-align: center;
  width: 60%;
  margin: auto;
  position: relative;
  top: 31px;
  padding: 2px 5px;
}
.rdv-info-body {
  background-color: #fff;
  padding-bottom: 15px;
  padding-top: 40px;
  border-radius: 20px;
  overflow: hidden;
}

#btn-confirm {
    background-color: var(--btn-primary-bg-color);
    color: var(--btn-primary-text-color);
}

#btn-confirm:hover {
    background-color: var(--btn-primary-bg-color-hover);
    color: var(--btn-primary-text-color);
}
</style>
